import {ISize} from "./Geom";

export const Scalable = {
    get scaleX() {
        return (this as any as PIXI.Container).scale.x;
    },
    set scaleX(value: number) {
        (this as any as PIXI.Container).scale.x = value;
    },
    get scaleY() {
        return (this as any as PIXI.Container).scale.y;
    },
    set scaleY(value: number) {
        (this as any as PIXI.Container).scale.y = value;
    },
    get scaleXY() {
        return (this as any as PIXI.Container).scale.x;
    },
    set scaleXY(value: number) {
        (this as any as PIXI.Container).scale.set(value);
    },
    get skewX() {
        return (this as any as PIXI.Container).skew.x;
    },
    set skewX(value: number) {
        (this as any as PIXI.Container).skew.x = value;
    },
    get skewY() {
        return (this as any as PIXI.Container).skew.y;
    },
    set skewY(value: number) {
        (this as any as PIXI.Container).skew.y = value;
    },
    setBounds(this: PIXI.Container, width: number | ISize, height?: number | "cover" | "stretch" | "fit", scaleMode?: "cover" | "stretch" | "fit"): void {
        if (typeof width !== "number") {
            scaleMode = height as "cover" | "stretch" | "fit";
            height = width.height;
            width = width.width;
        } else {
            height = height as number;
        }
        if (scaleMode === "stretch") {
            this.width = width;
            this.height = height;
        } else {
            this.scale.set(1);
            const s = scaleMode === "cover" ?
                Math.max(width / this.width, height / this.height) :
                Math.min(width / this.width, height / this.height);
            this.width *= s;
            this.height *= s;
        }
    },
};
